import React from 'react';
import { C } from '../theme';
import { Card, CardTitle, QuoteBox, Badge } from '../components/Card';

function Table({ title, badge, headers, rows }) {
  return (
    <Card>
      <CardTitle>{title} {badge && <Badge>{badge}</Badge>}</CardTitle>
      <div style={{overflowX:'auto',borderRadius:10}}>
        <table style={{width:'100%',borderCollapse:'collapse',fontSize:13}}>
          <thead>
            <tr>{headers.map(h=><th key={h} style={{background:'#1A1A35',color:C.gold,padding:'10px 12px',textAlign:'right',fontWeight:600,fontSize:12,letterSpacing:.3,borderBottom:`1px solid ${C.border}`}}>{h}</th>)}</tr>
          </thead>
          <tbody>
            {rows.map((row,i)=>(
              <tr key={i}>
                {row.map((cell,j)=>(
                  <td key={j} style={{padding:'10px 12px',borderBottom:`1px solid ${C.border}`,color:j===0?C.gold:C.text,lineHeight:1.5,fontFamily:j===0?'Amiri,serif':'Cairo,sans-serif',fontSize:j===0?16:13,fontWeight:j===0?700:'normal',verticalAlign:'top',whiteSpace:j===0?'nowrap':'normal'}}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}

export default function TablesScreen() {
  return (
    <div>
      <QuoteBox text="ما ظنّناه خياراً كان رقماً ينتظر أن يقع علينا... وما ظنّناه صدفة، كان جدولاً لم نفكّ شيفرته بعد" src="جذر الفلك، الجزء الثالث" />

      <Table title="جدول الأرقام المتكررة ومعانيها" badge="ج3"
        headers={['الرقم المتكرر','معنى الرسالة القدرية']}
        rows={[
          ['1:11 / 11:11','مرحلة بداية أو نداء ذاتي للانفصال عن القديم'],
          ['2:22 / 22','اختبار عاطفي أو تكرار قرار غير محسوم'],
          ['3:33 / 33','دعوة للتعبير أو التحرك الخارجي'],
          ['4:44 / 44','تحذير من التعلق أو الركود — استعد للانهيار أو إعادة البناء'],
          ['5:55 / 55','تغيّر مفاجئ — الباب سيُفتح أو يُغلق'],
          ['6:06 / 66','توتر داخلي عاطفي — راقب العلاقات'],
          ['7:07 / 77','حضور روحي أو رسالة من اللامرئي'],
          ['8:08 / 88','دورة مالية أو قدرية جديدة'],
          ['9:09 / 99','نهاية مرحلة أو اكتمال تعلم قديم'],
        ]}
      />

      <Table title="جدول الأرقام المضادة لتحرير الطاقة" badge="ج3"
        headers={['رقمك','الرقم المضاد','طريقة التفعيل']}
        rows={[
          ['1','6','وقّع اسمك 7 مرات تحت الرقم 6 لمدة 3 أيام قبل الشروق'],
          ['2','7','وقّع اسمك 7 مرات تحت الرقم 7 لمدة 3 أيام قبل الشروق'],
          ['3','4','وقّع اسمك 7 مرات تحت الرقم 4 لمدة 3 أيام قبل الشروق'],
          ['4','5','وقّع اسمك 7 مرات تحت الرقم 5 لمدة 3 أيام قبل الشروق'],
          ['5','8','وقّع اسمك 7 مرات تحت الرقم 8 لمدة 3 أيام قبل الشروق'],
          ['6','1','وقّع اسمك 7 مرات تحت الرقم 1 لمدة 3 أيام قبل الشروق'],
          ['7','2','وقّع اسمك 7 مرات تحت الرقم 2 لمدة 3 أيام قبل الشروق'],
          ['8','3','وقّع اسمك 7 مرات تحت الرقم 3 لمدة 3 أيام قبل الشروق'],
          ['9','1','وقّع اسمك 7 مرات تحت الرقم 1 لمدة 3 أيام قبل الشروق'],
        ]}
      />

      <Table title="جدول مفاتيح القرار الرقمي" badge="ج3"
        headers={['الرقم','طبيعة التردد','ما يُستحسن فعله']}
        rows={[
          ['1','اندفاعي تأسيسي','ابدأ مشروعاً — خذ خطوة شخصية جديدة'],
          ['2','عاطفي متردد','لا تقرر بعد — راقب — استشر'],
          ['3','اجتماعي سريع','اعرض فكرتك — تواصل — أعلن'],
          ['4','محافظ مُقيّد','راجع التفاصيل — لا تبدأ شيئاً جديداً'],
          ['5','تحرري مفتوح','جرّب — تنقّل — لا تتمسك بالخطط'],
          ['6','عاطفي مُصلح','وقت للمصالحات وتعزيز العلاقات'],
          ['7','روحاني عميق','تأمل — اكتب — لا تتسرع في القرارات'],
          ['8','ماديّ قوي','وقت ممتاز للأعمال المالية والمفاوضات'],
          ['9','ختامي اكتمالي','أنهِ ما بدأت — لا تفتح مشاريع جديدة'],
        ]}
      />

      <Table title="جدول التحذيرات الخفية لكل رقم" badge="ج3"
        headers={['الرقم','التحذير الخفي']}
        rows={[
          ['1','تقود من مكان ليس لك، وتخالف رغبة ذاتك'],
          ['2','هو "بوصلة مشروخة" — المسار الذي تسلكه ليس المسار المُقدَّر'],
          ['3','تذوب في الآخرين وتهمل صوتك الداخلي'],
          ['4','تضحك لتخفي ألماً لم تواجهه بعد'],
          ['5','تبني ما لا يشبهك لحماية من لا يراك'],
          ['6','تهرب من التكرار دون أن تختار مساراً بديلاً'],
          ['7','تداوي من لا يريد الشفاء وتهمل نفسك'],
          ['8','تقود من مكان القوة لكنك تحمل وحدة داخلية'],
          ['9','تُنهي ما لا يستحق الإنهاء وتُبقي ما يجب تركه'],
        ]}
      />

      <Table title="جدول ترددات الأرقام الصوتية" badge="ج1"
        headers={['الرقم','التردد (Hz)','الأثر الروحي']}
        rows={[
          ['1','396 Hz','التحرر من الخوف'],
          ['2','417 Hz','التحوّل الداخلي'],
          ['3','528 Hz','الشفاء وتنشيط DNA'],
          ['4','639 Hz','العلاقات والاتصال'],
          ['5','741 Hz','الحدس والتعبير'],
          ['6','852 Hz','العودة إلى الذات'],
          ['7','963 Hz','الارتباط بالوعي الأعلى'],
          ['8','111 Hz','إعادة توازن الطاقة'],
          ['9','432 Hz','التناغم الكوني'],
        ]}
      />

      <Table title="جدول الأرقام والكواكب المقابلة" badge="ج2"
        headers={['الرقم','الكوكب','تأثيراته الأساسية']}
        rows={[
          ['1','المريخ ♂','شجاعة، صراع، طاقة، قرار'],
          ['2','القمر ☽','رقة، تبدّل، حدس، تأثر'],
          ['3','عطارد ☿','حركة، فكر، تواصل، ذكاء'],
          ['4','الأرض/أورانوس','واقعية، تقنية، بناء، اختراع'],
          ['5','المشتري ♃','نمو، تفاؤل، تعليم، توسع'],
          ['6','الزهرة ♀','حب، فن، جمال، علاقات'],
          ['7','نبتون ♆','حدس، رؤى، أحلام، غموض'],
          ['8','الزهرة ♀','حب، فن، جمال، علاقات'],
          ['9','المريخ ♂','شجاعة، صراع، اكتمال'],
        ]}
      />
    </div>
  );
}
